import React from 'react';
import { useLocaleState, useRecordContext, useRefresh, useTranslate } from 'react-admin';
import { Button, Tooltip, useTheme } from '@mui/material'
import { listActionsColumnIconCommonStyle } from '../../themes/commonStyles';
import { archiveDeviceSubPlan } from '../../rest/restClient';



const Icon = ({ color }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-archive">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M3 4m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z" />
            <path d="M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-10" />
            <path d="M10 12l4 0" />
        </svg>
    )
}
const DeviceSubPlanArchiveButton = ({
    basePath = '',
    disabled,
    ...rest
}) => {
    const translate = useTranslate();
    const theme = useTheme();
    const record = useRecordContext();
    const [locale, setLocale] = useLocaleState()
    const refresh = useRefresh();
    const isLightMode = theme.palette.mode === 'light';
    const disabledColor = isLightMode ? theme.palette.grey[400] : theme.palette.grey[500];
    if (!record || record.plan_id === undefined) {
        return null
    }
    return (

        <Tooltip title={disabled ? "" : translate(`resources.device_sub_plans.archive`)} disableInteractive >

            <Button
                onClick={(e) => {
                    e.preventDefault();
                    archiveDeviceSubPlan({ planId: record.plan_id })
                        .then(res => {
                            if (res && res.status && res.status === 202) {
                                refresh()
                            }
                        }
                        )
                        .catch(err => { })

                }}
                style={listActionsColumnIconCommonStyle({ isLastItem: false })}>
                <Icon color={disabled ? disabledColor : theme.palette.primary.main} />
            </Button>
        </Tooltip>
    );
}



export default DeviceSubPlanArchiveButton;